import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteSubCategoryApi,
  getSubCategoryListApi,
  manageSubCategoryApi,
} from "helpers/ApiManager";
import { ApiResponse, PaginatedPayload } from "types/ApiResponse";
import {
  GetSubCategoryListApiArgs,
  ManageSubCategoryArgs,
  SubCategoryData,
} from "types/subcategory.api";
import { ErrorHandler, SuccessToast } from "utils/toast";

export const getSubCategories = createAsyncThunk<
  ApiResponse<PaginatedPayload<SubCategoryData>>, // return type
  GetSubCategoryListApiArgs | undefined, // argument type
  { rejectValue: string } // rejected type
>("subcategories/getSubcategories", async (params, { rejectWithValue }) => {
  try {
    const response = await getSubCategoryListApi(params);

    return response;
  } catch (err: any) {
    console.log(err);
    return rejectWithValue(err?.message || "Failed to fetch");
  }
});

export const deleteSubCategory = createAsyncThunk<
  ApiResponse<number>, // return type
  number, // argument type
  { rejectValue: string } // rejected type
>(
  "subcategories/deleteSubcategory",
  async (subcategoryId, { rejectWithValue }) => {
    try {
      const response = await deleteSubCategoryApi(subcategoryId);
      response.payload = subcategoryId;
      SuccessToast(response.message);
      return response;
    } catch (err: any) {
      ErrorHandler(err);
      return rejectWithValue(err?.message || "Failed to delete");
    }
  }
);

export const manageSubCategory = createAsyncThunk<
  ApiResponse<SubCategoryData>, // return type
  ManageSubCategoryArgs, // argument type
  { rejectValue: string } // rejected type
>("subcategories/manageSubcategories", async (params, { rejectWithValue }) => {
  try {
    const response = await manageSubCategoryApi(params);
    SuccessToast(response.message);
    return response;
  } catch (err: any) {
    ErrorHandler(err);
    return rejectWithValue(err?.message || "Failed to manage");
  }
});
